class FrequentlyBoughtTogether {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    // Add click handlers to all card ATC buttons
    const atcButtons = this.container.querySelectorAll('.fbt__card-atc-btn');
    atcButtons.forEach(button => {
      button.addEventListener('click', (e) => this.addToCart(e.currentTarget));
    });
  }

  async addToCart(button) {
    const variantId = button.dataset.variantId;

    if (!variantId) {
      return;
    }

    // Show loading state
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('btn--loading');

    try {
      // Get sections to bundle (same as PDP form)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      // Prepare config (same as PDP)
      const config = this.getFetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Create FormData - add single item
      const formData = new FormData();
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', 1);
      formData.append('sections', sectionsToBundle);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      // Add to cart (same endpoint as PDP)
      const response = await fetch(`${FoxTheme.routes.cart_add_url}`, config);
      const parsedState = await response.json();

      if (parsedState.status) {
        // Handle error - remove loading state before returning
        button.classList.remove('btn--loading');
        button.removeAttribute('aria-disabled');
        this.handleCartError(parsedState);
        return;
      }

      // Get updated cart (same as PDP)
      const cartResponse = await fetch(`${FoxTheme.routes.cart_url}`, { 
        ...this.getFetchConfig() 
      });
      const cartJson = await cartResponse.json();
      cartJson['sections'] = parsedState['sections'];

      // Update cart state (same as PDP)
      this.updateCartState(cartJson);
      
      // Dispatch product added event (same as PDP)
      this.dispatchProductAddedEvent(parsedState);

      // Show cart drawer (same as PDP)
      this.showCartDrawer(button);

    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      // Always remove loading state
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-disabled');
    }
  }

  // Same as theme's fetchConfig
  getFetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  // Same as PDP's updateCartState
  updateCartState(cartJson) {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  }

  // Same as PDP's dispatchProductAddedEvent
  dispatchProductAddedEvent(parsedState) {
    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: {
          product: parsedState,
        },
      })
    );
  }

  // Same as PDP's showCartDrawer
  showCartDrawer(button) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.show(button);
    }
  }

  // Handle cart errors (same as PDP)
  handleCartError(parsedState) {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'frequently-bought-together',
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message,
    });
    
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: parsedState.description,
        },
      })
    );
  }
}

// Initialize all frequently bought together components
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-fbt-container]');
  containers.forEach(container => {
    new FrequentlyBoughtTogether(container);
  });
});
